import React from 'react';
import { formatLabel } from 'utils/helpers';
import { hasContent, renderPrecautions } from './utils';

const PPESection = ({ chemicalDetails }) => {
  return (
    <div className="bg-white rounded-2xl shadow-lg p-8 border border-gray-100 transition-all duration-300 hover:shadow-xl">
      <h2 className="text-2xl font-bold mb-6">
        <i className="fas fa-shield-alt mr-2"></i>Personal Protective Equipment
      </h2>

      <div className='grid grid-cols-1 gap-6'>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <div className={`rounded-lg p-6 shadow border border-yellow-500 bg-yellow-100`}>
            <div className="font-bold text-lg mb-4">Precautions</div>
            <div>{renderPrecautions(chemicalDetails.ppe?.precautions)}</div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {chemicalDetails.ppe && Object.entries(chemicalDetails.ppe).map(([key, value]) => (
            hasContent(value) && key !== 'precautions' && (
              <div key={key} className={`rounded-lg p-6 shadow border bg-gray-50 ${key === 'precautions' ? 'border-yellow-500 bg-yellow-100' : ''}`}>
                <div className="font-bold text-lg mb-4">{formatLabel(key)}</div>
                
                {/* Render PPE items with images */}
                {key === 'precautions' ? (
                  <></>
                ) : (
                  <div className="space-y-3">
                    {Array.isArray(value) ? (
                      value.map((item, index) => {
                        // Handle both object format {id, name, code} and string format
                        const equipmentCode = typeof item === 'object' && item.code 
                          ? item.code 
                          : (typeof item === 'string' ? item.split(' - ')[0].trim().toLowerCase() : '');
                        const displayName = typeof item === 'object' && item.name 
                          ? item.name 
                          : item;
                        const imagePath = `/assets/${equipmentCode}.png`;
                        
                        return (
                          <div key={index} className="flex flex-col items-center gap-2 bg-white p-4 rounded-lg border border-gray-200 hover:shadow-md transition-shadow">
                            {/* PPE Image */}
                            <div className="flex-shrink-0 w-full aspect-square bg-gray-100 rounded-lg overflow-hidden flex items-center justify-center">
                              <img 
                                src={imagePath} 
                                alt={displayName}
                                className="w-full h-full object-contain p-2"
                                onError={(e) => {
                                  // Fallback to icon if image not found
                                  e.target.style.display = 'none';
                                  e.target.nextSibling.style.display = 'flex';
                                }}
                              />
                              <div className="hidden w-full h-full items-center justify-center text-gray-400">
                                <i className="fas fa-shield-alt text-4xl"></i>
                              </div>
                            </div>
                            
                            {/* PPE Text with additional details */}
                            <div className="text-center w-full">
                              <span className="text-sm font-semibold text-gray-800 block">{displayName}</span>
                              {typeof item === 'object' && (
                                <div className="text-xs text-gray-500 mt-1">
                                  {item.thickness && <span>{item.thickness}mm</span>}
                                  {item.class_type && <span>{item.class_type}</span>}
                                </div>
                              )}
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <span className="inline-block bg-blue-100 text-blue-800 text-sm font-semibold px-3 py-1 rounded-3xl border border-blue-200">{value}</span>
                    )}
                  </div>
                )}
              </div>
            )
          ))}
        </div>

      </div>
    </div>
  );
};

export default PPESection;
